module.exports = __webpack_public_path__ + "img/nav-logout-on.d36d31b4.png";